import { catalogStorage } from 'utils/catalogStorage';
import { AñoEscolar, Grado, Seccion, RolItem } from 'types/usuario.types';

interface BootstrapData {
  anioEscolarActivo: AñoEscolar | null;
  grados:            Grado[];
  secciones:         Seccion[];
  roles:             RolItem[];
}

const API = process.env.REACT_APP_API_URL ?? '';

export const bootstrapService = {
  async cargar(): Promise<BootstrapData> {
    const res = await fetch(`${API}/bootstrap`);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const body = await res.json();
    if (!body.success) throw new Error(body.message ?? 'Bootstrap error');
    const data = body.data as BootstrapData;

    if (data.grados?.length)            catalogStorage.saveGrados(data.grados);
    if (data.secciones?.length)         catalogStorage.saveSecciones(data.secciones);
    if (data.roles?.length)             catalogStorage.saveRoles(data.roles);
    if (data.anioEscolarActivo)         catalogStorage.saveAnioEscolarActivo(data.anioEscolarActivo);

    return data;
  },
};
